var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.iconData)?_c('span',{staticClass:"icon-wrapper",class:'icon-' + _vm.icon,domProps:{"innerHTML":_vm._s(_vm.iconData)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }